// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing {
    width: 100%;
}
.landing #map{
    width: 100%;
}

.dock-window {
    width: 100%;
    top: 100dvh;
    position: absolute;
    z-index: 1;
}

div.p-dialog-header:has(span.pi-window-maximize) {
  padding-top: 0px;
  padding-bottom: 0px;
}

.leaflet-top.leaflet-left .leaflet-control-scale {
  margin-top: 800px; /* << Ajuste este valor como quiser */
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/Home.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB,EAAE,qCAAqC;AAC1D","sourcesContent":[".landing {\n    width: 100%;\n}\n.landing #map{\n    width: 100%;\n}\n\n.dock-window {\n    width: 100%;\n    top: 100dvh;\n    position: absolute;\n    z-index: 1;\n}\n\ndiv.p-dialog-header:has(span.pi-window-maximize) {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.leaflet-top.leaflet-left .leaflet-control-scale {\n  margin-top: 800px; /* << Ajuste este valor como quiser */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
